<template>
    <section label="Powered by 135editor.com">
        <section>
            <h2 class="rich_media_title zhemo" id="activity-name">
                揭秘选股“黑科技”——量化多因子模型
            </h2>
            <p><span><br></span></p>
            <p><span>截至目前，A股的上市公司数量已超过3800家。随着股票数量的增多，市场风格切换以及题材热点的多元化，选股难度日益加大。有没有一种</span><strong><span>“黑科技”</span></strong><span>就像体检时的CT扫描一样，可以轻松判断个股的“可投资性”，进而帮助我们精准捕捉投资机会呢？今天我们就给大家好好介绍下神秘的</span><strong><span>量化多因子选股模型</span></strong><span>。</span>
            </p>
            <p><br></p>
            <p class="title2">
                1.什么是量化投资？
            </p>
            <p><br></p>
            <p><strong><span>量化投资是借助现代统计学、数学的方法，从海量历史数据中寻找能够带来超额收益的多种“大概率”策略，并纪律严明地按照这些策略所构建的数量化模型来指导投资，力求取得稳定的、可持续的、高于平均的超额回报。</span></strong><span>具有纪律性（不易受人交易的情绪影响）、历史依赖（未来历史会重演）、风险把握（风险收益比较高）、多样性（投资工具、品种多样）等特点。</span><br>
            </p>
            <p><br></p>
            <p><span>与传统投资相比，量化投资的优势体现在：</span></p>
            <p><span><br></span></p>
            <section>
                <section>
                    <section>
                        <p class="title2">①宽度制胜，突破人工极限</p>
                        <section>
                            <p>相对主动管理而言，量化投资可全面捕捉市场机会。如人脑很难覆盖全市场超过3000只股票的研究和筛选，而量化可比较容易处理。</p>
                        </section>
                    </section>
                </section>
            </section>
            <br>
            <section>
                <section>
                    <section>
                        <p class="title2">②纪律约束，克服人性弱点</p>
                        <section>
                            <p>市场情绪、业绩排名压力等外部因素往往会干扰基金经理的投资决策，导致组合业绩波动增大；而量化策略有着严格的纪律约束，克服人工构建组合的随意性。</p>
                        </section>
                    </section>
                </section>
            </section>
            <section>
                <section>
                    <section>
                        <section>
                            <section><strong><p class="title2">③机会丰富，发展空间巨大</p></strong></section>
                            <section><br></section>
                        </section>
                        <section>
                            <p>A股市场的历史仍然较短，尤其是散户成交占比较高；大量被“错杀”股票的“均值回归”，使得阿尔法模型获得超额收益的空间比成熟市场更大。</p>
                        </section>
                    </section>
                </section>
            </section>
            <section>
                <p><br></p>
            </section>
            <p class="title2">2.揭秘多因子模型</p>
            <p><br></p>
            <p><strong><span>股票多因子模型</span></strong><span>是国内量化投资领域应用最广、内涵最深、研究最多的量化选股模型。多因子模型建立在投资组合、资本资产定价（CAPM）、套利定价理论（APT）等现代金融投资理论基础上，它假设市场是无效或弱有效的，通过主动投资组合管理来获取超额收益。多因子选股的核心思想在于，<strong>市场影响因素是多重的并且是动态的，但是总会有一些因子在一定的时期内能发挥稳定的作用</strong>。因此，当我们采用一系列的因子作为选股条件，满足这些因子的股票则被买入，不满足则被卖出。</span>
            </p>
            <p><br></p>
            <p><span>接下来，我们来看看量化多因子模型是如何运作的？</span></p>
            <p><br></p>
            <p><span>以</span><strong><span>嘉合量化多因子模型</span></strong><span>为例，其投资策略框架如下所示，主要包括数据获取、数据处理、因子构建、单因子测试、多因子模型构建、组合优化、交易执行、绩效归因等模块。</span>
            </p>
            <p><br></p>
        </section>
        <p style='text-align:center;'><img class=""
                src="./img/img_2_9_1.png"
                alt="图片"><br></p>
        <p><span>多因子选股模型的第一步是发掘各类与股票收益率相关的因子。<strong>哪些因子可能成为选股的依据？这主要基于经济逻辑和市场经验。</strong>常见的Alpha因子包括</span><span>估值、成长、营运质量、流动性、波动与反转、分析师</span><span>等大类因子。</span><br>
        </p>
        <p><br></p>
        <p><img src="./img/img_2_9_2.png" style='max-width:100%;'
                alt="图片"
                width="520px"
                ></p>
        <p style="text-align:center;"><span>资料来源：嘉合基金</span></p>
        <p><br></p>
        <p><span>为了验证单个因子的有效性，我们会从</span><strong><span>因子分组收益</span></strong><span>、</span><strong><span>因子IC时间序列图</span></strong><span>等进行分析。如果因子分组收益区分越明显，表明因子效果越好。下图展示了质量因子的分组收益和IC时间序列图，可以看到其分组收益较好，IC均值以及为0.06，ICIR达3.1，因子效果较好。</span>
        </p>
        <section>
            <section>
                <section>
                    <section><br></section><br>
                </section>
            </section>
        </section>
        <section>
            <section><img title="图 1.png" style='max-width:50%;' class=""
                    src="./img/img_2_9_3.png"
                    alt="图片"><img title="图2.png" style='max-width:50%;' class=""
                    src="./img/img_2_9_4.png"
                    alt="图片"></section>
        </section>
        <section style="text-align:center;"><span>资料来源：Wind、嘉合基金</span>
            <section><br></section>
        </section>
        <section>
            <section><br></section>
        </section>
        <p><span>模型构建方面，我们通常会根据多个因子的线性加权来为个股进行综合打分，并剔除上市不满6个月、ST、涨跌停、停牌等股票。但如果仅选用得分最高的一篮子股票构建组合，在一些极端市场环境下可能会产生较大的回撤风险，因此还需要对组合进行优化。<strong>在组合优化时，我们通过控制个股偏度、行业市值中性，力求在每个月度跑赢基准指数。</strong></span>
        </p>
        <p><br></p>
        <p><span>经过测算，</span><strong><span>采用嘉合量化多因子模型建立的投资组合，策略月度胜率为84.26%</span></strong><span>，即策略每年有10个月都能跑赢中证500指数。并且在牛市中，比中证500涨的更多，在熊市中比中证500跌的更少。</span>
        </p>
        <p><br></p>
        <section>
            <section>
                <section>
                    <section>
                        <section><span>
                                <section>
                                    <p class="title2"><strong><span>牛市期间，策略跑赢中证500指数38%</span></strong></p>
                                </section>
                            </span></section>
                        <section>
                            <p style="text-align:center;"><img src="./img/img_2_9_5.png" style="width:520px;"
                                    alt="图片"></p>
                        </section>
                    </section>
                </section>
            </section>
        </section>
        <section>
            <section>
                <section>
                    <p  class="title2"><strong><span>短期熊市期间，策略跑赢中证500指数6%</span></strong></p>
                    <section>
                        <p style="text-align:center;"><img src="./img/img_2_9_6.png" style="width:520px;"
                            alt="图片"></p>
                    </section>
                </section>
            </section>
        </section>
        
        <p class="free">（来源：嘉财万贯）</p>
    </section>
</template>

<script>
    export default {

    }
</script>

<style scoped>
    .zhemo {
        text-align: center;
        padding: 40px 0 20px 0;
        font-weight: bold;
        color: #6f6f6f !important;
    }

    .title2 {
        font-weight: bold;
        line-height: 30px;
    }

    p,
    span {
        text-indent: 2em;
        font-size: 14px !important;
        color: #6f6f6f !important;
        letter-spacing: 0 !important;
    }
</style>